import { AUPredictor } from '@quarkworks-inc/avatar-webkit';

export enum AUPredictorQuality {
  Low = 'low',
  High = 'high',
}

export class AvatarPredictor {
  private predictor: AUPredictor;

  constructor(config: { predictionQuality?: AUPredictorQuality }) {
    this.predictor = new AUPredictor({
      apiToken: process.env.NEXT_PUBLIC_AVATAR_WEBKIT_AUTH_TOKEN,
      shouldMirrorOutput: false,
      fps: 30,
      predictionQuality: config.predictionQuality || AUPredictorQuality.Low,
    });
  }

  async start(stream, cb) {
    // predictor doesn't work without a video track
    const hasVideoTrack = stream?.getTracks?.().some((track) => track.kind === 'video');
    if (!hasVideoTrack) {
      throw new Error('Video track not found.');
    }

    await this.predictor.start({ stream });
    this.predictor.dataStream.subscribe(cb);
  }

  async stop() {
    await this.predictor.stop();
  }
}
